export default __webpack_public_path__ + "d823178d5b2cc940d8f25d7c6673b022.png";